import PageHero from "@/components/PageHero";
import CityStatsBar from "@/components/CityStatsBar";
import TopCitiesShowcase from "@/components/TopCitiesShowcase";
import TeamsBlock from "@/components/TeamsBlock";
import Sectors from "@/components/Sectors";
import CityNotListedCTA from "@/components/CityNotListedCTA";
import { SEO_CITIES_TEXT } from "@/lib/data";
import SEO from "@/components/SEO";

const Villes = () => {
  return (
    <div data-testid="page-villes">
      <SEO
        title="Villes, Saint-Malo, Dinard, Cancale, Dinan, Damgan & Morbihan"
        description="Conciergerie Airbnb à Saint-Malo, Dinard, Cancale, Dinan, Saint-Cast, Damgan, La Roche-Bernard et toute la Bretagne (35 · 22 · 56). Deux équipes locales dédiées."
        keywords="conciergerie Airbnb Saint-Malo, conciergerie Airbnb Dinard, conciergerie Airbnb Cancale, conciergerie Airbnb Dinan, conciergerie Airbnb Damgan, conciergerie Airbnb La Roche-Bernard, conciergerie Côte d'Émeraude, conciergerie Morbihan, conciergerie Côtes-d'Armor, conciergerie Ille-et-Vilaine"
        breadcrumbs={[
          { name: "Accueil", path: "/" },
          { name: "Villes", path: "/villes" },
        ]}
      />

      {/* === ACT 1, HERO : promesse territoriale === */}
      <PageHero
        overline="Villes d'intervention"
        title="Présents partout en"
        italic="Bretagne"
        description="Deux équipes locales dédiées : l'une à Saint-Malo et sur la Côte d'Émeraude (35 · 22), l'autre dans le Morbihan (56). Un accueil voyageur de proximité et une réactivité immédiate, où que se trouve votre bien."
        image="https://images.pexels.com/photos/12715501/pexels-photo-12715501.jpeg?auto=compress&cs=tinysrgb&dpr=2&h=900&w=1800"
        overlayImage="/images/sticker-tm.png"
        overlayAlt="Sticker Terre et Mer Conciergerie, Nous nous occupons de ce logement"
      />

      {/* === ACT 2, STATS : 30 villes, 3 dépts, 70 logements, 30 min === */}
      <CityStatsBar />

      {/* === ACT 3, TOP DESTINATIONS : Saint-Malo, Dinard, Cancale, Dinan === */}
      <TopCitiesShowcase />

      {/* === ACT 4, INTERACTIVE MAP + LOCAL TEAMS === */}
      <TeamsBlock />

      {/* === ACT 5, ALL OTHER CITIES BY SECTOR === */}
      <Sectors />

      {/* === ACT 6, CTA : VILLE ABSENTE ? === */}
      <CityNotListedCTA />

      {/* === ACT 7, SEO LONG-TAIL FOOTER === */}
      <section
        className="bg-sand py-16 border-t border-gold/20"
        data-testid="seo-zone"
      >
        <div className="container-tm">
          <p className="overline mb-4">Zones d'intervention principales</p>
          <p className="font-sans text-xs md:text-sm text-ink/55 leading-relaxed">
            {SEO_CITIES_TEXT.join(", ")}.
          </p>
        </div>
      </section>
    </div>
  );
};

export default Villes;
